import { EnumSessionType } from "../../../unit-conversion/src/generated/graphql";

// FreePractice
// Qualifying
// Race
// Setup
// Simulation
// SessionNotification
// Test
// InternalMeeting
// ExternalMeeting
// VirtualMeeting
// Info
// EventSchedule
// Team
// ParcFerme
// DiL

type SessionForTypeFilter = {
  sessionType?: EnumSessionType | null | undefined;
};

export const shouldShowOnProtocolDropdown = (session: SessionForTypeFilter) => {
  if (!session?.sessionType) return true;
  return (
    session.sessionType === EnumSessionType.FreePractice ||
    session.sessionType === EnumSessionType.Qualifying ||
    session.sessionType === EnumSessionType.Race ||
    session.sessionType === EnumSessionType.Setup ||
    session.sessionType === EnumSessionType.Simulation ||
    session.sessionType === EnumSessionType.Test ||
    session.sessionType === EnumSessionType.DiL
  );
};

export const isRunningSession = (session: SessionForTypeFilter) => {
  if (!session?.sessionType) return true;
  return (
    session.sessionType === EnumSessionType.FreePractice ||
    session.sessionType === EnumSessionType.Qualifying ||
    session.sessionType === EnumSessionType.Race ||
    session.sessionType === EnumSessionType.Test ||
    session.sessionType === EnumSessionType.DiL
  );
};
